export type PayNowTileType = {
  caseNo: string;
  currency: string | null;
  isClosed: boolean;
  isPaid: boolean;
  isPaymentsFuncTurnOn: boolean;
  enablePartialPayment: boolean;
  saldo: string;
  originalClaim: string;
  paid: string;
  caseCosts: string;
  originalCurrencyClaim: string | null;
  originalCurrency: string | null;
};

export const emptyPayNowTileType: PayNowTileType = {
  caseNo: '',
  currency: null,
  isClosed: false,
  isPaid: false,
  isPaymentsFuncTurnOn: false,
  enablePartialPayment: false,
  saldo: '0',
  originalClaim: '0',
  paid: '0',
  caseCosts: '0',
  originalCurrencyClaim: null,
  originalCurrency: null,
};
